import React, {Component} from 'react';
import enumTamanios from '../../../Enums/tamanios'
import enumEdades from '../../../Enums/edades'
import enumSexo from '../../../Enums/sexo'
import {browserHistory} from "react-router";
import ShareButtonsBox from "../../../../Shared/components/SocialMediaButtons/ShareButtonsBox";
import {PATH_ADOPTAR_ID, PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID, PATH_PROTECTORA_ID} from "../../../../../App/RouterAdopta";
import Descripcion from "../../../../Shared/components/components/Descripcion/Descripcion";
import CardImagesAnimalDetail from "./CardImagesAnimalDetail";
import ListFeatures from "../../../../Shared/components/components/ListFeatures/ListFeatures";
import NewContactComponent from "../../../../Shared/components/Contact/NewContactComponent";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../../analytics/config/analyticsParamsFrontEnd";
import {sendEvent} from "../../../../../analytics/analitycs"
import {ADS_TYPES, AdsManagerContainer} from "../../../../Ads/components/AdsManagerContainer";


class NewCardInfoDetailAnimal extends Component {

    constructor(props) {
        super(props);

        // this.props.isLogin();
        this.state = {
            modeEmail_2: false,
            showModalContactByEmail: false
        }
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoAnimal",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Quieres saber más?"],
            messageWhatsapp: "Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20de%20" + this.props.infoAnimalDetail.nombre + "%20",
            idSelect: "contactoAnimal",
            divSelect: ".divSelectContactoAnimal",
            tipo: 'animal'
        };


        //Config información
        this.configFeatures = {
            title: "Características",
            features: [
                {
                    classIcon: "las la-3x  la-paw",
                    label: "Estado",
                    value: this.props.infoAnimalDetail.estado
                },
                {
                    classIcon: "las la-3x  la-birthday-cake",
                    label: "Edad",
                    value: new enumEdades().convertir(this.props.infoAnimalDetail.edad)
                },
                {
                    classIcon: "las la-3x  la-tint",
                    label: "Color",
                    value: this.props.infoAnimalDetail.color.toString().charAt(0) + this.props.infoAnimalDetail.color.join(', ').toString().slice(1).toLowerCase()
                },
                {
                    classIcon: "las la-3x  la-transgender",
                    label: "Sexo",
                    value: new enumSexo().convertir(this.props.infoAnimalDetail.sexo)
                },
                {
                    classIcon: "las la-3x  la-arrows-alt-v",
                    label: "Tamaño",
                    value: new enumTamanios().convertir(this.props.infoAnimalDetail.tamano)
                },
                {
                    classIcon: "las la-3x  la-syringe",
                    label: "Vacunas",
                    value: (this.props.infoAnimalDetail.vacunas ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-venus-mars",
                    label: "Mestizo",
                    value: (this.props.infoAnimalDetail.mestizo ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-hand-scissors",
                    label: "Esterilizado",
                    value: (this.props.infoAnimalDetail.esterilizado ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-stethoscope",
                    label: "Sano",
                    value: (!this.props.infoAnimalDetail.enfermedades ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-exclamation-triangle",
                    label: "PPP",
                    value: (this.props.infoAnimalDetail.ppp ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-microchip",
                    label: "Chip",
                    value: (this.props.infoAnimalDetail.chip ? "Si" : "No")
                },
                {
                    classIcon: "las la-3x  la-users",
                    label: "Caracter",
                    value: this.props.infoAnimalDetail.caracter.toString().charAt(0) + this.props.infoAnimalDetail.caracter.join(', ').toString().slice(1).toLowerCase()
                }]
        };


        this.changeModeEmail = this.changeModeEmail.bind(this);
        this.handleModify = this.handleModify.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
        this.onClickShareButton = this.onClickShareButton.bind(this);
    }

    handleModify(idAnimal) {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + idAnimal);
    }


    handleDelete() {
        this.props.removing(true, this.props.animalsControl);
        this.props.changeWaitBlock(true);
    }


    clickLinkDescripcion() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ANIMAL.LINK_DESCRIPCION, {id_animal: this.props.infoAnimalDetail._id});
    }

    clickLinkTeamingDescripcion() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ANIMAL.TEAMING_DESCRIPCION, {id_animal: this.props.infoAnimalDetail._id});
    }

    clickEmailDescripcion() {
        // this.setState({modeEmail_2: true})
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.ANIMAL.EMAIL_DESCRIPCION, {id_animal: this.props.infoAnimalDetail._id});
    }

    changeModeEmail(mode) {
        this.setState({modeEmail_2: mode})
    }

    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")

            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }

        return tkn;
    }

    onClickShareButton(socialMedia) {
        sendEvent(TIPOS_EVENTOS.SHARE, ELEMENTS.ANIMAL.ANIMAL, {
            id_animal: this.props.infoAnimalDetail._id,
            sharedOn: socialMedia
        })
    }


    render() {
        //console.log("NewCardInfoDetailAnimal::render()");
        const error = this.props.infoAnimalDetail.error;
        let showInfo;
        let direccion;

        Object.keys(this.props.infoAnimalDetail).length === 0 || error ? showInfo = false : showInfo = true;
        const especie = this.props.infoAnimalDetail.especie;
        let classSource = "";


        const direccionObj = this.props.infoAnimalDetail.direccion;
        if (direccionObj != null && (direccionObj.ocultar_direccion_exacta || direccionObj.ocultar_direccion_exacta === undefined)) {
            direccion = "Zona de " + direccionObj.municipio + ", " + direccionObj.provincia;
        } else if (direccionObj != null && !direccionObj.ocultar_direccion_exacta && direccionObj.calle && direccionObj.numero) {
            direccion = direccionObj.calle + ", " + direccionObj.numero + ", " + direccionObj.municipio + ", " + direccionObj.provincia
        } else if (direccionObj != null && direccionObj.municipio && direccionObj.provincia) {
            direccion = direccionObj.municipio + " (" + direccionObj.provincia + ")"
        } else {
            direccion = "Consultar dirección";
        }

        let nombre = this.capitalizeString(this.props.infoAnimalDetail.nombre)
        let raza = this.props.infoAnimalDetail.raza.join(', ').replace(/,(?!.*,)/gmi, ' y')
        raza = this.capitalizeString(raza)

        let loc = (direccionObj && direccionObj.municipio) ? direccionObj.municipio : (direccionObj && direccionObj.region) ? direccionObj.region : direccionObj.provincia


        let licenciaPPP = this.props.infoAnimalDetail.ppp

        let nombreProtectora = ""
        if (this.props.infoProtectoraDetail && this.props.infoProtectoraDetail.nombre) {
            nombreProtectora = this.props.infoProtectoraDetail.nombre
        }

        let srcImagen = this.props.infoAnimalDetail.img_principal && this.props.infoAnimalDetail.img_principal.url
            ? this.props.infoAnimalDetail.img_principal.url
            : process.env.CDN_URL + '/images/adoptaunanimal/default/' + (especie.toLowerCase()) + '.png'
        // : getImageEncode("default." + especie.toLowerCase())

        let galeria_imagenes = this.props.infoAnimalDetail.galeria_imagenes

        let tipoProtectoraTitle = "De la protectora "
        let tipoEntidad = this.props.infoProtectoraDetail.tipo_entidad;
        if (tipoEntidad && ["Asociación", "Asociación CES"].includes(tipoEntidad)) {
            tipoProtectoraTitle = "De la " + tipoEntidad
        } else if (tipoEntidad && ["Municipal"].includes(tipoEntidad)) {
            tipoProtectoraTitle = "De la protectora " + tipoEntidad + " de "
        } else if (tipoEntidad && ["Refugio", "Albergue"].includes(tipoEntidad)) {
            tipoProtectoraTitle = "Del " + tipoEntidad
        }
        const title = (this.props.infoAnimalDetail.estado === "Adoptado") ? "ya ha sido adoptado" : "en adopción"
        return (
            <div key={"cardInfo-" + this.props.infoProtectoraDetail._id} className="card animalDetail">
                {this.props.infoAnimalDetail.estado === "Adoptado" && <div className="cardInfoTitle">
                    {(this.props.infoAnimalDetail.estado !== "Adoptado") &&
                        <h1 className="">
                            {this.capitalizeString(especie)}<span className="bold"> {raza}</span> en adopción cerca
                            de <span className="bold"> {loc}</span>
                        </h1>
                    }
                    {(this.props.infoAnimalDetail.estado === "Adoptado") &&
                        <h1 className="">
                            {this.props.infoAnimalDetail.nombre}<span
                            className="bold"> ya ha sido adoptado </span> cerca
                            de <span className="bold"> {loc}</span>
                        </h1>
                    }
                </div>
                }
                <div className=" ">
                    {showInfo &&
                        <div className="newCardInfoDetailShow">
                            <div className="cardInfoTitle">

                                <h3>{nombre}</h3>
                                {nombreProtectora &&
                                    <h2>
                                <span className="">
                                    <i className="las la-lg la-home"></i>
                                    {' '}{tipoProtectoraTitle} <span className="bold">{nombreProtectora}</span>
                                </span>

                                    </h2>
                                }
                            </div>
                            <div className="informationDetailDescriptionUp">
                                <div className="informationDetailDescriptionLeft">

                                    <LazyLoadImage
                                        className="embed-responsive"
                                        src={srcImagen}
                                        threshold={150}
                                        alt={"Foto de " + {nombre} + " un " + raza + " en adopción cerca de " + {loc}}
                                    />
                                </div>
                                <div className="informationDetailDescriptionUpRight informationDetailProtectora">

                                    <div className="informationDetail informationDetailHeader ">
                                        <ul>
                                            <li>
                                                <span className="las la-3x la-transgender"/>
                                                <span className="sexo"> Sexo </span>
                                                <span
                                                    className="sexo-data">{new enumSexo().convertir(this.props.infoAnimalDetail.sexo)}</span>
                                            </li>
                                            <li>
                                                <span className="las la-3x la-birthday-cake"/>
                                                <span className="edad"> Edad </span>
                                                <span
                                                    className="edad-data">{new enumEdades().convertir(this.props.infoAnimalDetail.edad)}</span>
                                            </li>

                                            <li>
                                                <span className="las la-3x la-arrows-alt-v"/>
                                                <span className="tamano"> Tamaño </span>
                                                <span
                                                    className="tamano-data">{new enumTamanios().convertir(this.props.infoAnimalDetail.tamano)}</span>
                                            </li>
                                            {licenciaPPP &&
                                                <li>
                                                    <span className="las la-3x la-exclamation-triangle"/>
                                                    <span className="ppp"> PPP </span>
                                                    <span
                                                        className="ppp-data">{(this.props.infoAnimalDetail.ppp ? "Si" : "No")}</span>
                                                </li>
                                            }

                                        </ul>

                                    </div>
                                    <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS} onlyDesktop/>
                                    <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS} onlyMobile/>

                                    <div className="informationDetailProtectora__row-100">
                                        <div className="div-rrss-contacto-protectora">
                                            <NewContactComponent
                                                infoProtectoraDetail={this.props.infoProtectoraDetail}
                                                infoAnimalDetail={this.props.infoAnimalDetail}
                                                tipoContacto={"animal"}

                                                urlWhastapp={process.env.HOST_ADOPTA + PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                                configEstadoContacto={this.configEstadoContacto}
                                                animalsControl={this.props.animalsControl}
                                                animalsControlDetail={this.props.animalsControlDetail}
                                                changeModeEmail={this.changeModeEmail}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className=" text-left">
                                <div className="moreProtectoraInfo">
                                    <h4>Compartir</h4>
                                    <ShareButtonsBox
                                        shareURL={process.env.HOST_ADOPTA + PATH_ADOPTAR_ID + this.props.infoAnimalDetail._id}
                                        permalink={PATH_ADOPTAR_ID + this.props.infoAnimalDetail._id}
                                        text={""}
                                        hashtags={["AdoptaNoCompres"]}
                                        onClickShareButton={this.onClickShareButton}
                                        stickyMode
                                        normalMode
                                    />
                                </div>
                            </div>
                            <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>

                            <hr/>

                            <div className="sub-section">

                                <Descripcion
                                    // title={"Descripción de " +this.props.infoAnimalDetail.nombre}
                                    descripcion={this.props.infoAnimalDetail.descripcion}
                                    onClickLink={this.clickLinkDescripcion}
                                    onClickLinkTeaming={this.clickLinkTeamingDescripcion}
                                    onClickEmail={this.clickEmailDescripcion}
                                    hideEmail={false}
                                    adsConfig={{
                                        // adsTypes: [ADS_TYPES.ROBAPAGINAS,ADS_TYPES.SPLITSCREEN],
                                        adsTypes: [ADS_TYPES.SPLITSCREEN, ADS_TYPES.ROBAPAGINAS],
                                        insertAtEnd: true
                                    }}
                                />
                            </div>
                            {/*<AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>*/}

                            {galeria_imagenes && galeria_imagenes.length > 0 &&
                                <div className="sub-section">
                                    <hr/>

                                    <CardImagesAnimalDetail
                                        animalDetail={this.props.infoAnimalDetail}
                                        animalsControl={this.props.animalsControl}
                                        animalsControlDetail={this.props.animalsControlDetail}
                                        idAnimal={this.props.infoAnimalDetail._id}
                                        index={this.props.index}
                                    />
                                    <AdsManagerContainer type={ADS_TYPES.ROBAPAGINAS}/>
                                </div>
                            }
                            <hr/>


                            <div className="sub-section">

                                <ListFeatures
                                    title={this.configFeatures.title}
                                    features={this.configFeatures.features}
                                />
                            </div>


                        </div>
                    }

                </div>
            </div>

        );
    }

    componentWillMount() {
        ////console.log("CardInfoDetailProtectora::componentWillMount() --> this.props.idAnimal=["+this.props.idAnimal+"]");
    }


}


export default NewCardInfoDetailAnimal
